import { APIError } from '../core/errors';
import httpClient from '../services/http.service';
import { BASE_URL } from './api-constants';


const _api_base_url = `${BASE_URL}/content/instore-promotions`;

interface promotionResponse {
  
  content :{
    [key: string]: string

  };
  images:{

    [key: string]: string
  };
}

export const getPromo = async(storeCode: string | null): Promise<promotionResponse> => {
  try {
    let url = _api_base_url;

    url += `?subType=${storeCode?storeCode:1234}`
    const response = await httpClient.get(url);
    return response.data;
} catch (error) {
    console.error(error);
    throw new APIError(error);
}
};
